import { Node } from 'prosemirror-model';

export const imageNode: object = {
  inline: true,
  attrs: {
    attachmentId: { default: '' },
    src: { default: '' },
    handledSrc: { default: '' },
    originalSrc: { default: '' },
    title: { default: '' },
    alt: { default: '' },
    width: { default: null },
    height: { default: null },
  },
  group: 'inline',
  draggable: true,
  parseDOM: [
    {
      tag: 'img[src]',
      getAttrs: (dom: HTMLElement) => ({
        attachmentId: dom.getAttribute('attachmentId') || '',
        src: dom.getAttribute('src'),
        originalSrc: dom.getAttribute('src') || dom.getAttribute('originalSrc'),
        title: dom.getAttribute('title') || '',
        alt: dom.getAttribute('alt') || '',
        width: dom.getAttribute('width') || dom.style['width'] || '100%',
        height: dom.getAttribute('height') || dom.style['height'] || '100%',
      }),
    },
  ],
  toDOM: ({ attrs }: Node) => [
    'img',
    {
      attachmentId: attrs.attachmentId,
      src: attrs.handledSrc,
      title: attrs.title || '',
      alt: attrs.alt || '',
      ...(attrs.originalSrc ? { originalSrc: attrs.originalSrc } : {}),
      width: attrs.width,
      height: attrs.height,
    },
  ],
};
